import React from 'react';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import Thumbnail from '@components/@core/Thumbnail';

const moment = extendMoment(originalMoment);

const Courses = ({ track }) => {
    return (
        <div className="card">
            <p className="dsl-b16 bold">Courses</p>
            <div className="d-flex py-2 border-bottom">
                <div className="d-flex-3 dsl-m12">{`Courses(${track?.cards?.length || 0})`}</div>
                <div className="d-flex-1 dsl-m12 text-end">Modules</div>
                <div className="d-flex-1 dsl-m12 text-end">Due</div>
                <div className="d-flex-1 dsl-m12 text-end">Compl.</div>
            </div>
            {track?.cards?.map((course, index) => {
                const thumbnail = course.data?.thumb_url || course?.thumbnail;

                return (
                    <div className="d-flex py-3 cursor-pointer border-bottom" key={index}>
                        <div className="d-flex d-flex-3">
                            <Thumbnail source={thumbnail} size="small" />
                            <div className="ml-4">
                                <p className="dsl-b14 text-400 mb-1">{course.name}</p>
                                <p className="dsl-m12 mb-0 text-400">Assigned: Manager</p>
                            </div>
                        </div>
                        <div className="d-flex-1 dsl-b14 text-400 text-end">{course?.data?.module_count || 0}</div>
                        <div className="d-flex-1 dsl-b14 text-400 text-end">{moment(track?.due_date).format('MMM D, YY')}</div>
                        <div className="d-flex-1 dsl-b14 text-400 text-end">0</div>
                    </div>
                );
            })}
        </div>
    );
};

export default Courses;
